// Import modules
import mobileMenu from './modules/mobile-menu.js';
import modal from './modules/modal.js';
import notification from './modules/notification.js';
import Swiper from 'swiper/bundle';
import { Fancybox } from '@fancyapps/ui';
import Sticky from './modules/sticky.js';
import stickyHeader from './modules/sticky-header.js';
import searchPanel from './modules/search-panel.js';
import copyLink from './modules/copy-link.js';
import cookieRenew from './modules/cookie-renew.js';
import adIframes from './modules/ad-iframes.js';

// Init functions
function init() {
	// init fancybox
	Fancybox.bind('[data-fancybox]');

	// init mobile menu --> wp-content/themes/expl-theme/source/scripts/modules/mobile-menu.js
	mobileMenu();

	// init sticky header (.is-stuck after 80px) --> modules/sticky-header.js
	stickyHeader();

	// HTML5 ad iframes scaled to their block --> modules/ad-iframes.js
	adIframes();

	// init search panel under the header --> modules/search-panel.js
	searchPanel();

	// init "Link kopiëren" in the article share row --> modules/copy-link.js
	copyLink();

	// init "Cookievoorkeuren" (legal menu) → Cookiebot.renew() --> modules/cookie-renew.js
	cookieRenew();

	// init modal --> wp-content/themes/expl-theme/source/scripts/modules/modal.js
	modal();


	// init notification --> wp-content/themes/expl-theme/source/scripts/modules/notification.js
	// init notification popup
	document.querySelector('.notification-popup') &&
		notification('.notification-popup', 'notification-popup', 1000);

	// init notification snackbar
	document.querySelector('.notification-snackbar') &&
		notification('.notification-snackbar', 'notification-snackbar', 2000);


	// Home hero slider (templates/grids/news/grid-header-home.php); only with 2+ slides.
	// Labels come from data attributes (theme text domain); no autoplay with reduced motion.
	var heroEl = document.querySelector('.nm-hero__swiper');
	if (heroEl && heroEl.querySelectorAll('.swiper-slide').length > 1) {
		var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		new Swiper(heroEl, {
			loop: false,
			speed: reduceMotion ? 0 : 500,
			autoplay: reduceMotion ? false : { delay: 6000, disableOnInteraction: true, pauseOnMouseEnter: true },
			pagination: { el: '.nm-hero__pagination', clickable: true },
			navigation: { nextEl: '.nm-hero__next', prevEl: '.nm-hero__prev' },
			keyboard: true,
			lazyPreloadPrevNext: 1,
			a11y: {
				prevSlideMessage: heroEl.dataset.msgPrev,
				nextSlideMessage: heroEl.dataset.msgNext,
				paginationBulletMessage: heroEl.dataset.msgBullet,
				slideLabelMessage: heroEl.dataset.msgSlide,
				containerRoleDescriptionMessage: heroEl.dataset.msgCarousel,
			},
		});
	}

	var ArticleImgSlider = new Swiper(".article-img-slider", {
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		keyboard: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: true
		},
	});

	var sticky = new Sticky('.sidebar-inner');

}

// Run the init function when the page loads
window.onload = init;
